module.exports = __webpack_public_path__ + "assets/img/nature-pop-bg.309f4b9b.png";